import { Button } from '../../../subkit-ui';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageTopBar = function LandingPageTopBar(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex justify-between px-4 md:px-42 h-22.5",
    children: [/*#__PURE__*/_jsx("img", {
      className: "my-6 self-start",
      src: "/images/img_logo.png",
      style: {
        height: '36px'
      },
      alt: "Subkit Logo"
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-1 min-w-4"
    }), /*#__PURE__*/_jsx(Button, {
      classes: "my-6 px-2 md:px-12 font-dmsans fw-500",
      text: props.buttonText,
      href: props.buttonLink,
      type: "secondary",
      size: "sm",
      "data-cy": "LandingPageTopBarButton"
    })]
  });
};

export default LandingPageTopBar;